import { useEffect } from "react";

import {
    useBaseIdentityAttrs,
    useFireAnalyticsEvents
} from "@/components/fastshift/analytics";
import {
    SourceKey,
    ActionKey,
    ActionSubjectKey
} from "@/components/fastshift/analytics/constants";
import { useFastshiftSelector } from "@/components/fastshift/src/state";

export const useCustomerSelectionPageAnalytics = () => {
    const identityAttrs = useBaseIdentityAttrs();
    const { data: customerDomains, pending: customerDomainsPending } =
        useFastshiftSelector((state) => state.customerDomains);

    const { fireScreenEvent, fireTrackEvent } =
        useFireAnalyticsEvents(identityAttrs);

    // Screen event
    useEffect(() => {
        if (!identityAttrs) return;
        fireScreenEvent({
            name: SourceKey.FASTSHIFT_PORTAL_SELECTION_SCREEN
        });
    }, [fireScreenEvent, identityAttrs]);

    // Track event
    useEffect(() => {
        if (!identityAttrs || !customerDomains || customerDomainsPending) {
            return;
        }
        fireTrackEvent({
            action: ActionKey.DISPLAYED,
            actionSubject: ActionSubjectKey.SELECTION_PAGE_DETAILS,
            source: SourceKey.FASTSHIFT_PORTAL_SELECTION_SCREEN,
            attributes: {
                customerDomainCount: customerDomains.data.length
            }
        });
    }, [
        fireTrackEvent,
        identityAttrs,
        customerDomains,
        customerDomainsPending
    ]);
};
